import { useCallback } from 'react';
import { getWalkthrough } from '@/lib/guideRegistry';
import { useGuidesStore } from '@/stores/useGuidesStore';

interface Props {
  id: string;
}

export function WalkthroughLink({ id }: Props) {
  const walkthrough = getWalkthrough(id);
  const openWalkthrough = useGuidesStore((s) => s.openWalkthrough);

  const handleClick = useCallback(() => {
    if (walkthrough) openWalkthrough(walkthrough.id);
  }, [walkthrough, openWalkthrough]);

  if (!walkthrough) {
    if (import.meta.env.DEV) {
      console.warn(`<WalkthroughLink id="${id}"> — walkthrough not found in registry`);
    }
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-purple-600 underline decoration-purple-400 decoration-dotted underline-offset-2 hover:text-purple-800"
    >
      {walkthrough.content.label}
    </button>
  );
}
